import {
  CardCvcElement,
  Elements,
  ElementsConsumer,
} from '@stripe/react-stripe-js';
import dayjs from 'dayjs';
import _ from 'lodash';
import React, { useMemo, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { BsXLg } from 'react-icons/bs';
import { createUseStyles } from 'react-jss';
import tinycolor from 'tinycolor2';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseCardBrandImageUrl } from '../../utils/manager/card-manager';

const backgroundColor = '#F8F8F8';
const height = 58;

//
// Coletar novamente um CVC
//
// https://docs.stripe.com/payments/save-card-without-authentication#web-recollect-cvc
// https://docs.stripe.com/radar/rules#traditional-bank-checks

function PaymentCardListItem({
  card,
  isSelected,
  onSelect,
  onDelete,
  onCVCChange,
  disabled,
  stripe,
  elements,
  payment,
  onSuccess,
  onError,
  isUnderError,
}) {
  const [, setError] = useState();
  const inputRef = useRef();
  const formRef = useRef();
  const promiseRef = useRef();
  const promiseResolverRef = useRef();
  const classes = useStyles({ isUnderError });

  const charge = async () => {
    promiseRef.current = new Promise((resolve) => {
      promiseResolverRef.current = resolve;
    });

    await formRef.current.requestSubmit();
    await Promise.all([promiseRef.current]);
  };

  const handleOnClick = () => {
    if (!isSelected) {
      onSelect?.call(this, { card, setError, charge });
      onCVCChange?.call(this, null);

      _.delay(() => {
        inputRef.current?.focus();
      }, layoutDefaults.keyboardDuration);
    }
  };

  const handleOnDelete = (event) => {
    event.stopPropagation();
    onDelete?.call(this, card);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const cardCvc = elements.getElement('cardCvc');
    const clientSecret = payment.card?.client_secret;

    const result = await stripe.confirmCardPayment(clientSecret, {
      // `Elements` instance that was used to create the Payment Element
      // elements,
      // redirect: 'if_required',
      // confirmParams: {
      //   return_url: 'https://example.com/order/123/complete',
      // },
      payment_method: card.id,
      payment_method_options: {
        card: {
          cvc: cardCvc,
        },
      },
    });

    if (result.error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      // setMessage(result.error.message);
      // result.error.handleGeneric = false;
      onError?.call(this, result.error, false);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.

      onSuccess?.call(this, result);
    }

    promiseResolverRef.current();
  };

  // const handleOnCVCChange = (event) => {
  //   const { value } = event.target;
  //   setCVC(value);
  // };

  return (
    <div className={classes.container}>
      <form ref={formRef} onSubmit={disabled ? null : handleSubmit}>
        <div
          className={classes.content}
          onClick={handleOnClick}
          // onKeyDown={handleOnClick}
          // role="button"
          // tabIndex={0}
          aria-hidden
        >
          <Form.Check
            // disabled
            type="radio"
            size="lg"
            disabled={disabled}
            checked={isSelected}
            className={classes.radio}
            readOnly={false}
            onChange={() => {}}

            // label={`disabled ${type}`}
            // id={`disabled-default-${type}`}
          />
          <img
            src={parseCardBrandImageUrl(card)}
            alt={card.brand}
            className={classes.brand}
          />
          <div className={classes.data}>
            {/* <div>{card.expiration.month}</div>
      <div>{card.expiration.year}</div> */}
            {!isSelected && (
              <div className={classes.expiration}>
                {dayjs(
                  `${card.expiration.year}/${card.expiration.month}`,
                  'YYYY/MM'
                ).format('MMM/YY')}
              </div>
            )}
            <div className={classes.number}>
              **** {card.last4}
              {/* {`**** ${card.last4}`.split('').reverse().join('')} */}
            </div>
          </div>
          {!isSelected && (
            <BsXLg className={classes.delete} onClick={handleOnDelete} />
          )}
          {isSelected && (
            <CardCvcElement
              // ref={inputRef}
              forwardRef={inputRef}
              // placeholder="CVC/CVV"
              // isInvalid={error}
              className={classes.input}
              // options={{
              //   classes: {
              //     empty: classes.inputEmpty,
              //   },
              // }}
              // inputMode="numeric"
              // defaultValue=""
              // type="password"
              // name="cvc"
              // security="cvc"
              // value={cvc}
              // maxLength={4}
              // autoCapitalize="none"
              // autoCorrect="off"
              // spellCheck={false}
              // autoComplete="off"
              // onChange={handleOnCVCChange}
            />
          )}
        </div>
      </form>

      {/* {isSelected && <div>Informe o código de segurança</div>} */}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginBottom: layoutDefaults.smallVerticalMargin,
    // border: '1px solid red',
  },
  content: {
    // overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: height,

    fontSize: layoutDefaults.fontSize,
    // flex: 1,
    // justifyContent: 'space-between',
    backgroundColor,
    paddingLeft: layoutDefaults.bigHorizontalMargin,
    paddingRight:
      layoutDefaults.horizontalMargin - layoutDefaults.smallerHorizontalMargin,

    borderRadius: layoutDefaults.radius,
    // border: '1px solid red',
    border: `1px solid ${tinycolor(layoutDefaults.buttonBorder).toRgbString()}`,
  },
  radio: {
    borderColor: layoutDefaults.buttonBorder,
    // borderRadius: layoutDefaults.radius,
  },
  data: {
    display: 'flex',
    flex: 1,
    fontSize: layoutDefaults.bigFontSize,
    alignItems: 'center',
    // fontSize: layoutDefaults.fontSize,
    justifyContent: 'space-between',
    // marginLeft: layoutDefaults.horizontalMargin,
    marginRight: layoutDefaults.horizontalMargin,
  },
  number: {
    //
  },
  expiration: {
    // whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    opacity: layoutDefaults.opacity,
    // fontSize: layoutDefaults.smallestFontSize,
    fontSize: layoutDefaults.fontSize,
  },
  brand: {
    height: 40,
    marginLeft: layoutDefaults.smallerHorizontalMargin,
    // marginTop: layoutDefaults.smallVerticalMargin,
    // marginBottom: layoutDefaults.smallVerticalMargin,
    // borderRadius: layoutDefaults.radius,
    // border: '1px solid red',

    // border: '1px solid red',
  },
  delete: {
    opacity: layoutDefaults.opacity,
    marginRight: layoutDefaults.smallHorizontalMargin,
  },
  input: {
    // visibility: 'hidden',
    width: 104,
    // fontSize: layoutDefaults.biggerFontSize,
    border: ({ isUnderError }) =>
      isUnderError
        ? `2px solid ${layoutDefaults.destructiveColor}`
        : `1px solid ${layoutDefaults.buttonBorder}`,
    backgroundColor: 'white',
    paddingTop:
      layoutDefaults.smallVerticalMargin +
      layoutDefaults.smallestVerticalMargin,
    paddingBottom:
      layoutDefaults.smallVerticalMargin +
      layoutDefaults.smallestVerticalMargin,
    paddingLeft: layoutDefaults.horizontalMargin,
    paddingRight: layoutDefaults.horizontalMargin,
    borderRadius: layoutDefaults.radius,
    borderWidth: 1,
    borderColor: layoutDefaults.buttonBorder,
  },
  // inputEmpty: {
  //   color: 'red',
  // },
});

function StripeElementsConsumer(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <PaymentCardListItem {...props} stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
  );
}

function StripeBodyWrapper(props) {
  // const {loadStripeClientIdFromRemote} = useTempAPI();
  const { clientSecret, menuLayout, stripePromise } = props;
  const font = menuLayout?.text?.default_font;

  // useEffect(() => {
  //   console.log('clientSecret');
  //   console.log(clientSecret);
  // }, [clientSecret]);

  // const [clientId, setClientId] = useState();

  // useEffect(() => {
  //   async function init() {
  //     const response = await loadStripeClientIdFromRemote();
  //     setClientId(response.data);
  //   }

  //   init();
  // }, []);

  console.log('layout');
  console.log(menuLayout?.text?.default_font);

  // const stripePromise = useMemo(
  //   () => loadStripe(config?.stripe?.api_key),
  //   [config?.stripe]
  // );

  const appearance = useMemo(
    () => ({
      theme: 'stripe',
      variables: {
        fontSizeBase: layoutDefaults.smallFontSize,
        // fontWeightNormal: 100,
        // colorText: layoutDefaults.textPlaceholderColor,
        // colorTextSecondary: layoutDefaults.textPlaceholderColor,
        // colorTextSecondary: 'red',
        // colorPrimaryText: layoutDefaults.primaryColor,
        // colorPrimaryText: 'red',
        // colorTextSecondary: 'red',
        // colorPrimaryText: 'red',
        colorText: layoutDefaults.primaryColor,
        // colorText: layoutDefaults.buttonBorder,
        colorTextPlaceholder: layoutDefaults.buttonBorder,
        colorDanger: layoutDefaults.destructiveColor,
        fontFamily: menuLayout?.text?.default_font,
        // fontWeight: 100,
      },
    }),
    [menuLayout]
  );

  const options = useMemo(
    () => ({
      loader: 'always',
      clientSecret,
      fonts: [
        {
          cssSrc: `https://fonts.googleapis.com/css?family=${font}:200,400,500,600`,
        },
      ],
      appearance,
      classes: {
        empty: {
          color: 'red',
        },
      },
    }),
    [appearance, clientSecret]
  );

  if (!clientSecret) {
    return null;
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      <StripeElementsConsumer {...props} />
    </Elements>
  );
}

export {
  StripeBodyWrapper as PaymentCardListItem,
  backgroundColor as cardBackgroundColor,
  height as cardHeight,
};
